import React, {Fragment} from "react";
import MsdsList from "./List";
import MsdDetail from "./Detail";
import EnhancedModal from "../../../components/enhanced-modal";
import {Button, Modal} from "antd";
import {
  ARTEFACT_TYPE_MSD,
  ARTEFACT_TYPE_MULTIPLE,
  DOWNLOAD_FORMAT_TYPE_CSV,
  getArtefactDownloadOptions
} from "../../../constants/download";
import {MODAL_WIDTH_MD, MODAL_WIDTH_SM} from "../../../styles/constants";
import ArtefactDownloadForm from "../../../components/artefact-download-form";
import {
  changeMsdsMsdClone,
  changeMsdsMsdDownload,
  changeMsdsMsdExport,
  downloadMsdsMsd,
  hideMsdsMsdClone,
  hideMsdsMsdDownload,
  hideMsdsMsdExport,
  hideMsdsMsdExportReport,
  submitMsdsMsdClone,
  submitMsdsMsdExport
} from "./actions";
import {compose} from "redux";
import {connect} from 'react-redux';
import {translate} from 'react-i18next';
import ArtefactExportForm from "../../../components/artefact-export-form";
import {isCloneDestTripletValid, isExportDestinationValid} from "../../../utils/artefactValidators";
import ArtefactCloneForm from "../../../components/artefact-clone-form";
import ArtefactExportReport from "../../../components/artefact-export-report";
import {getStringFromArtefactTriplet} from "../../../utils/sdmxJson";

const mapStateToProps = state => ({
  endpoints: state.config.nodes,
  endpointId: state.app.endpointId,
  msd: state.scenes.metaManager.msds.msd,
  downloadMsdParams: state.scenes.metaManager.msds.downloadMsdParams,
  downloadMsdTriplets: state.scenes.metaManager.msds.downloadMsdTriplets,
  downloadMsdLang: state.scenes.metaManager.msds.downloadMsdLang,
  allAgencies: state.scenes.metaManager.msds.allAgencies,
  cloneDestTriplet: state.scenes.metaManager.msds.cloneDestTriplet,
  msdExportSourceTriplet: state.scenes.metaManager.msds.msdExportSourceTriplet,
  msdExportDestination: state.scenes.metaManager.msds.msdExportDestination,
  msdExportReport: state.scenes.metaManager.msds.msdExportReport,
  user: state.app.user
});

const mapDispatchToProps = dispatch => ({
  onCloneHide: () => dispatch(hideMsdsMsdClone()),
  onCloneChange: fields => dispatch(changeMsdsMsdClone(fields)),
  onCloneSubmit: (cloneDestTriplet, srcMsd, annotationsConfig) =>
    dispatch(submitMsdsMsdClone(cloneDestTriplet, srcMsd, annotationsConfig)),
  onExportHide: () => dispatch(hideMsdsMsdExport()),
  onExportChange: fields => dispatch(changeMsdsMsdExport(fields)),
  onExportSubmit: (sourceTriplet, destination) => dispatch(submitMsdsMsdExport(sourceTriplet, destination)),
  onExportReportHide: () => dispatch(hideMsdsMsdExportReport()),
  onDownloadHide: () => dispatch(hideMsdsMsdDownload()),
  onDownloadChange: fields => dispatch(changeMsdsMsdDownload(fields)),
  onDownload: (msdTriplets, downloadMsdParams, lang) =>
    dispatch(downloadMsdsMsd(msdTriplets, downloadMsdParams, lang))
});

const Msds = ({
                t,
                msd,
                endpoints,
                endpointId,
                downloadMsdParams,
                downloadMsdTriplets,
                downloadMsdLang,
                allAgencies,
                cloneDestTriplet,
                msdExportSourceTriplet,
                msdExportDestination,
                msdExportReport,
                user,
                onCloneHide,
                onCloneChange,
                onCloneSubmit,
                onExportHide,
                onExportChange,
                onExportSubmit,
                onExportReportHide,
                onDownloadHide,
                onDownloadChange,
                onDownload
              }) =>
  <Fragment>
    <MsdsList/>
    <MsdDetail/>
    <EnhancedModal
      visible={cloneDestTriplet !== null}
      width={MODAL_WIDTH_MD}
      title={t('commons.artefact.modals.clone.title')}
      onCancel={onCloneHide}
      footer={
        <div>
          <Button onClick={onCloneHide}>
            {t('commons.buttons.close.title')}
          </Button>
          <Button
            onClick={() => {
              if (!isCloneDestTripletValid(cloneDestTriplet)) {
                Modal.warning({
                  title: t('commons.alerts.invalidForm.title'),
                  content: t('commons.alerts.invalidForm.content')
                });
              } else {
                onCloneSubmit(cloneDestTriplet, msd,
                  endpoints.find(endpoint => endpoint.general.id === endpointId).annotations
                )
              }
            }}
            type="primary"
          >
            {t('commons.artefact.modals.clone.buttons.submit.title')}
          </Button>
        </div>
      }
    >
      <ArtefactCloneForm
        agencies={allAgencies}
        srcArtefact={msd}
        destTriplet={cloneDestTriplet}
        onChange={onCloneChange}
      />
    </EnhancedModal>
    <EnhancedModal
      visible={msdExportSourceTriplet !== null}
      title={t('commons.artefact.modals.export.title')}
      width={MODAL_WIDTH_MD}
      onCancel={onExportHide}
      footer={
        <div>
          <Button onClick={onExportHide}>{t('commons.buttons.close.title')}</Button>
          <Button
            type="primary"
            onClick={() => {
              if (isExportDestinationValid(msdExportDestination, (user && user.providerId) !== null)) {
                onExportSubmit(msdExportSourceTriplet, msdExportDestination)
              } else {
                Modal.warning({
                  title: t('commons.alerts.invalidForm.title'),
                  content: t('commons.alerts.invalidForm.content')
                });
              }
            }}
          >
            {t('commons.artefact.modals.export.buttons.submit.title')}
          </Button>
        </div>
      }
    >
      <ArtefactExportForm
        type='metadatastructure'
        agencies={allAgencies}
        sourceTriplet={msdExportSourceTriplet}
        destination={msdExportDestination}
        onChange={onExportChange}
        withReferences
      />
    </EnhancedModal>
    <EnhancedModal
      visible={msdExportReport !== null}
      title={t('commons.artefact.modals.exportReport.title')}
      width={MODAL_WIDTH_MD}
      onCancel={onExportReportHide}
      footer={<Button onClick={onExportReportHide}>{t('commons.buttons.close.title')}</Button>}
    >
      <ArtefactExportReport
        report={msdExportReport}
      />
    </EnhancedModal>
    <EnhancedModal
      visible={downloadMsdTriplets !== null && downloadMsdTriplets !== undefined}
      onCancel={onDownloadHide}
      footer={
        <div>
          <Button onClick={onDownloadHide}>
            {t('commons.buttons.close.title')}
          </Button>
          <Button
            onClick={
              () => onDownload(downloadMsdTriplets, downloadMsdParams, downloadMsdLang)
            }
            type="primary"
            disabled={
              (downloadMsdParams && downloadMsdParams.format === null) ||
              (downloadMsdParams && downloadMsdParams.format === DOWNLOAD_FORMAT_TYPE_CSV &&
                (
                  downloadMsdParams.csvSeparator === null ||
                  downloadMsdParams.csvSeparator.length !== 1 ||
                  downloadMsdParams.csvLanguage === null
                ))
            }
          >
            {t('commons.buttons.download.title')}
          </Button>
        </div>
      }
      width={MODAL_WIDTH_SM}
      title={
        downloadMsdTriplets && downloadMsdTriplets.length > 1
          ? t('scenes.metaManager.commons.modals.download.titleMulti')
          : t('scenes.metaManager.commons.modals.download.title', {
            triplet: downloadMsdTriplets
              ? getStringFromArtefactTriplet(downloadMsdTriplets[0])
              : ""
          })
      }
    >
      <ArtefactDownloadForm
        downloadArtefactForm={downloadMsdParams}
        onChange={onDownloadChange}
        options={getArtefactDownloadOptions(
          t,
          (downloadMsdTriplets && downloadMsdTriplets.length > 1)
            ? ARTEFACT_TYPE_MULTIPLE
            : ARTEFACT_TYPE_MSD
        )}
        hasReferences
      />
    </EnhancedModal>
  </Fragment>;

export default compose(
  translate(),
  connect(mapStateToProps, mapDispatchToProps)
)(Msds);


// WEBPACK FOOTER //
// ./src/scenes/meta-manager/msds/index.jsx